const originKeys = ['position', 'marginLeft', 'marginTop', 'marginRight', 'marginBottom', 'margin', 'paddingLeft', 'paddingTop', 'paddingRight', 'paddingBottom', 'padding', 'backgroundColor', 'borderRadius', 'borderLine', 'borderBox', 'boxShadow', 'class', 'adapt']

const numberKeys = ['top', 'left', 'bottom', 'right', 'minWidth', 'minHeight', 'maxWidth', 'maxHeight'];

import Env from 'common/env';

export default {
    data() {
        return {
            baseOneSpace: 1,
            customBackgroundColor: '',
            defaultLayout: {
                position: '',
                marginLeft: 0,
                marginTop: 0,
                marginRight: 0,
                marginBottom: 0,
                margin: '',
                paddingLeft: 0,
                paddingTop: 0,
                paddingRight: 0,
                paddingBottom: 0,
                padding: '',
                backgroundColor: '',
                borderRadius: '',
                borderLine: '',
                borderBox: '',
                boxShadow: '',
                class: '',
                adapt: false
            }
        }
    },
    props: {
    },
    computed: {
        realLayout () {
            return Object.assign(this.defaultLayout, (this.styleObject || {}))
        },
        realRatio () {
            let width;
            if(Env.isCSR) {
                width = Env.getCSR().getSystemInfo().windowWidth;
            }else{
                width = document.documentElement.clientWidth;
            }
            return this.realLayout.adapt && width < 359 ? 0.853 : 1
        },
        borderLine () {
            return this.realLayout.borderLine
        },
        borderBox () {
            return this.realLayout.borderBox
        },
        layoutPosition () {
            return this.realLayout.position
        },
        finalMargin () {
            let margin;
            let res = '';

            if(this.realLayout.margin) {
                margin = ('' + this.realLayout.margin).trim()
            }else {
                margin = `${this.realLayout.marginTop} ${this.realLayout.marginRight} ${this.realLayout.marginBottom} ${this.realLayout.marginLeft}`
            }

            if(margin === '0 0 0 0') {
                return res;
            }

            margin = margin.split(' ');
            (margin || []).forEach(e => {
                res += `${this.baseOneSpace * this.realRatio * (+e)}px `
            });

            return res
        },
        finalPadding () {
            let padding;
            let res = '';

            if(this.realLayout.padding) {
                padding = ('' + this.realLayout.padding).trim()
            }else {
                padding = `${this.realLayout.paddingTop} ${this.realLayout.paddingRight} ${this.realLayout.paddingBottom} ${this.realLayout.paddingLeft}`
            }

            if(padding === '0 0 0 0') {
                return res;
            }

            padding = padding.split(' ');
            (padding || []).forEach(e => {
                res += `${this.baseOneSpace * this.realRatio * (+e)}px `
            });

            return res
        },
        finalBackgroundColor () {
            let bgColor = this.realLayout.backgroundColor
            if(bgColor.indexOf('#')> -1 || bgColor.indexOf('rgb') > -1) {
                this.customBackgroundColor = bgColor
                return '';
            }else {
                this.customBackgroundColor = '';
                return bgColor
            }
        },
        finalBorderRadius () {
            let radius = '' + (this.realLayout.borderRadius);
            if(!radius) return '';

            if(radius.indexOf('%') > -1) {
                return radius
            }
            return `${this.baseOneSpace * (radius)}px`
        },
        borderRadius () {
            let radius = ('' + this.realLayout.borderRadius);
            radius = radius.split(' ');
            radius.forEach((item, index) => {
                if(item.indexOf('%') == -1) {
                    radius[index] = item + 'px';
                }
            })
            return radius.join(' ')
        },
        originBorderRadius () {
            return this.realLayout.borderRadius
        },
        finalBoxShadow () {
            return this.realLayout.boxShadow
        },
        className () {
            return this.realLayout.class
        },
        extraStyle () {
            let obj = {};
            for(let key in this.styleObject) {
                if(originKeys.indexOf(key) === -1) {
                    let val = this.styleObject[key];
                    if(numberKeys.indexOf(key) > -1) {
                        obj[key] = ('' + val).indexOf('%') > -1 ? val : (val + 'px')
                    }else {
                        obj[key] = val
                    }
                }
            }

            return obj
        }
    },
    created () {
    },
    mounted () {
    },
    methods: {
    },
}